export * from './components';
export * from './sections';

import * as components from './components';
import * as sections from './sections';

export function loadComponents(registry) {
	Object
		.values(components)
		.forEach((component) => {
			const { type } = component;
			registry.addField(type, component);
		});

	Object
		.values(sections)
		.forEach((section) => {
			const { type } = section;
			registry.addSection(type, section);
		});
}